import axios from 'axios';

export type BaseResponse<T = null> = {
  data: T;
};

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SERVER_API + '/api',
  timeout: 3000,
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
    'Content-Type': 'application/json'
  },
  responseEncoding: 'utf-8',
  responseType: 'json'
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let message = '';
    switch (error.response.status) {
      case 400:
        // serverData.data = Object with error messages like: {email: ["Este valor no es una dirección de email válida."]}
        message =
          'Algo no ha ido como debería, revisa todos los campos e inténtalo de nuevo. Si el error persiste contacta con soporte.';
        break;
      case 401:
      case 403:
        message = 'Usuario no autorizado.';
        break;
      case 404:
        message = 'Recurso no disponible.';
        break;
      case 500:
        message = 'Servicio no disponible en estos momentos. Por favor, inténtalo de nuevo más tarde.';
        break;
    }
    throw new Error(message);
  }
);

export default axiosInstance;
